module.exports = __webpack_public_path__ + "img/CB34-Off-1.84560d83.png";